import {useState} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {useAuthContext} from './useAuthContext';
import {getSessionOperator} from "../helper/session";
import LoadingScreen from "../components/loading-screen";
import DeparturePreview from "../pages/DeparturePreview";
import {OPERATORS_GROUP} from "../constants";
import {BarriersPage} from "../routes/elements";
import LoginLayout from "../layouts/login/LoginLayout";

// ----------------------------------------------------------------------

const AuthStatus = {
    AUTHENTICATED: 'AUTHENTICATED',
    NOT_AUTHENTICATED: 'NOT_AUTHENTICATED',
    AUTHENTICATED_AS_OPERATOR: 'AUTHENTICATED_AS_OPERATOR',
    AUTHENTICATED_AS_TRIP_PREVIEW: 'AUTHENTICATED_AS_TRIP_PREVIEW',
    AUTHENTICATED_AS_DISPATCHER: 'AUTHENTICATED_AS_DISPATCHER',
    AUTHENTICATED_AS_BARRIER_PREVIEW: 'AUTHENTICATED_AS_BARRIER_PREVIEW',
    AUTHENTICATED_AS_INFORMER_PREVIEW: 'AUTHENTICATED_AS_INFORMER_PREVIEW',
};


export default function AuthGuard({children}) {
    const operator = getSessionOperator();
    const {isAuthenticated, isInitialized} = useAuthContext();
    const {pathname} = useLocation();
    const [requestedLocation, setRequestedLocation] = useState(null);
    if (!isInitialized) {
        return <LoadingScreen/>;
    }

    const determineAuthStatus = () => {
        if (!isAuthenticated) {
            return AuthStatus.NOT_AUTHENTICATED;
        }
        if (!operator) {
            return AuthStatus.AUTHENTICATED_AS_OPERATOR;
        }
        if (isAuthenticated && operator && operator?.group === OPERATORS_GROUP.tripPreview) {
            return AuthStatus.AUTHENTICATED_AS_TRIP_PREVIEW;
        }
        if (isAuthenticated && operator && operator?.group === OPERATORS_GROUP.dispatcher) {
            return AuthStatus.AUTHENTICATED_AS_DISPATCHER;
        }
        if (isAuthenticated && operator && operator?.group === OPERATORS_GROUP.barrier) {
            return AuthStatus.AUTHENTICATED_AS_BARRIER_PREVIEW;
        }
        if (isAuthenticated && operator && operator?.group === OPERATORS_GROUP.informer) {
            return AuthStatus.AUTHENTICATED_AS_INFORMER_PREVIEW;
        }
        return AuthStatus.AUTHENTICATED;
    };

    const authStatus = determineAuthStatus();

    if (authStatus === AuthStatus.NOT_AUTHENTICATED) {
        if (pathname !== requestedLocation) {
            setRequestedLocation(pathname);
        }
        return <LoginLayout/>;
    }

    if (authStatus === AuthStatus.AUTHENTICATED_AS_OPERATOR) {
        if (pathname !== requestedLocation) {
            setRequestedLocation(pathname);
        }
        return <LoginLayout/>;
    }

    if (authStatus === AuthStatus.AUTHENTICATED_AS_TRIP_PREVIEW) {
        if (pathname !== requestedLocation) {
            setRequestedLocation(pathname);
        }
        return <DeparturePreview/>;
    }

    if (authStatus === AuthStatus.AUTHENTICATED_AS_BARRIER_PREVIEW) {
        if (pathname !== requestedLocation) {
            setRequestedLocation(pathname);
        }
        return <BarriersPage/>;
    }

    if (requestedLocation && pathname !== requestedLocation) {
        setRequestedLocation(null);
        return <Navigate to={requestedLocation}/>;
    }

    return <>{children}</>;
}


